import React, { forwardRef, useState, useCallback } from 'react';
import { InputProps } from './types';
import { Input as ChakraInput } from '@chakra-ui/react';
import { withInputAddons } from './hoc';
import { FieldTypes } from '../../';

const InputWithElements = withInputAddons('Input')(ChakraInput);

export const Input = forwardRef<HTMLInputElement, InputProps>(({ type, ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = useCallback(() => setShowPassword(!showPassword), [showPassword]);

  return (
    <InputWithElements
      ref={ref}
      data-object-type="input"
      type={type === FieldTypes.password && showPassword ? FieldTypes.text : type}
      {...props}
      toggleShowPassword={type === FieldTypes.password ? toggleShowPassword : undefined}
      showPassword={type === FieldTypes.password ? showPassword : undefined}
    />
  );
});

Input.displayName = 'Input';
